export default 'walletAccounts';
